export default "__VITE_ASSET__00df2cb9__"